// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"bc1f7fe1","189":"876b6642","331":"34209bbe","453":"02cace9c","555":"d25324d5","615":"e84bfe6a","818":"2d572f04"}[chunkId] + ".chunk.js";
};